<template>
    <div class="rightbar">
      <ul>
          <li v-for="(item,index) in floatList" :key="index">
              <img :src="$common.getImgUrl(item.floatingPic)">
          </li>
      </ul>
    </div>
</template>

<script>
export default {
    components: { },
    data() {
        return {
            floatList: [],
            scrollTop: 0,
        };
    },
    created() {
        this.$http.get(this.$api.getListFloatingWindows).then((res) => {
            if (res.code == 0) {
                this.floatList = res.data.sort((item1, item2) => {
                    return item2.sort - item1.sort;
                });
            }
        });
    },
    mounted() {
        let self = this;
        window.onscroll = function () {
            let num = document.documentElement.scrollTop || document.body.scrollTop;
            self.scrollTop = num;
        };
    },
    methods: {
        // 回到顶部
        returnGo() {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        openPage(type) {
            
        },
        // 自助客服
        toNewCustomerService() {
            //新客服
            var _this = this;
            var obj = {};
            obj.host = _this.$common.getHost();
            obj.clientCode = window.clientCode;
            obj.clientItem = window.childCode;
            obj.username = this.$common.getUser() && this.$common.getUser().username;
            obj.language = this.$common.getLocale();
            obj.theme = window.theme;
            obj.projectImgUrl = window.projectImgUrl;
            obj.orgin = window.location.origin + "/activity";
            var str = JSON.stringify(obj);
            str = window.btoa(str);
            // var url =
            //     _this.$config.customerServiceUrl +
            //     "/customerService/pc?s=" +
            //     str;
            var url = location.origin + "/func/customerService/pc?s=" + str;
            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss" >
.rightbar {
    ul {
        li {
            width: 90px;
            height: 90px;
            margin-bottom: 10px;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
                &:hover {
                    opacity: .9;
                }
            }
        }
    }
}
</style>